import { Module } from 'vuex';
import { HotelStoreInterface } from '../../../../types/store/hotelStoreInterface';
import HotelService from '../../../../services/wizard/hotel.service';
import { CustomPosInterface } from '@/types/api/wizard/hotels/customPosInterface';

const getDefaultState = () => {
  return {
    list: [],
    listLoading: false,
  };
};

const hotelStore: Module<HotelStoreInterface, any> = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state: any) {
      const s: any = getDefaultState();
      Object.keys(s).forEach(key => {
        state[key] = s[key];
      });
    },
    listLoading(state, payload: boolean) {
      state.listLoading = payload;
    },
    listLoaded(state, payload: Array<any>) {
      state.list = payload;
    },
  },
  actions: {
    getList({ commit }, accountID: number): any {
      commit('listLoading', true);
      return HotelService.getHotels({ account_id: accountID })
        .then((res: any) => {
          commit('listLoaded', res.data);
          return res.data;
        })
        .catch((error: any) => {
          return error;
        })
        .finally(() => {
          commit('listLoading', false);
        });
    },
    getDetails(state, data: any): any {
      return HotelService.getHotelDetails(data);
    },
    activateGMO(state, data: any): any {
      return HotelService.activateGMO(data);
    },
    activateJTB(state, data: any): any {
      return HotelService.activateJTB(data);
    },
    activateStripe(state, data: any): any {
      return HotelService.activateStripe(data);
    },
    activatePoA(state, data: any): any {
      return HotelService.activatePoA(data);
    },
    setPosData(state, data: CustomPosInterface): any {
      return HotelService.customPos(data);
    },
    publishHotel(state, data: any): any {
      return HotelService.publishHotel(data);
    },
    unpublishHotel(state, data: any): any {
      return HotelService.unpublishHotel(data);
    },
    startHotelAri(state, data: any): any {
      return HotelService.startHotelAri(data);
    },
    stopHotelAri(state, data: any): any {
      return HotelService.stopHotelAri(data);
    },
  },
};

export default hotelStore;
